// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3vMX7","validationTips":"StatementDescriptor_validationTips__2cCaJ"};